import getCMSDomain from "./getCMSDomain";
import getEnvironment from "./getEnvironment";

const getSaleChannelParam = (branchName?: string): string => {
  switch (branchName) {
    case "Hybrid":
      return "Hybrid";
    case "Online Only":
    default:
      return "e-Auction";
  }
};

export const buildPreviewLotsUrl = (
  saleLocation: string | string[],
  saleType: string | string[],
  saleDate: string,
  branchName?: string
) => {
  const environment = getEnvironment();
  const buyerAPIDomain = getCMSDomain(environment);
  const saleChannel = getSaleChannelParam(branchName);

  let url = `${buyerAPIDomain}search?requestOrigin=Sales&q=&sort=LotSequence&bq=salechannel:${saleChannel}`;

  if (saleLocation) {
    if (typeof saleLocation === "string") {
      url += `|salelocation:${saleLocation}`;
    }

    if (Array.isArray(saleLocation)) {
      url += `|salelocation:${saleLocation.join(",")}`;
    }
  }

  if (saleType) {
    if (typeof saleType === "string") {
      url += `|saletype:${saleType}`;
    }

    if (Array.isArray(saleType)) {
      url += `|saleType:${saleType.join(",")}`;
    }
  }

  if (saleDate) {
    url += `|saledate:${saleDate}`;
  }

  return url;
};
